<template>
  <fragment>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle="`accordion-${index}`">
          <div class="question"><b-icon-chevron-down /> {{ question }}</div>
          <span class="star">(Average Star: {{ point }})</span>
          <em>{{ comments.length }} comment(s)</em></b-button
        >
      </b-card-header>
      <b-collapse v-if="comments.length > 0" :id="`accordion-${index}`" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card v-for="(comment, idx) in comments" :key="idx">{{ comment }}</b-card>
        </b-card-body>
      </b-collapse>
    </b-card>
  </fragment>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
    },
    point: {
      type: Number,
    },
    comments: {
      type: Array,
      default() {
        return [];
      },
    },
    question: {
      type: String,
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/colors';

a {
  text-align: left;
  font-size: 1.6rem;
  background-color: $gray;
  color: black;
  border: none;

  display: flex;
  align-items: center;

  .question {
    flex: 3;
  }

  .star {
    flex: 1;
    margin-left: 1rem;
  }
}

.btn-secondary:focus,
.btn-secondary:hover,
a:active {
  background-color: $gray !important;
  color: black !important;
}

em {
  font-size: 1.2rem;
}
</style>
